import axios from 'axios';
import { put, call, takeLeading } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import Swal from "sweetalert2";
import {
    get_roles, create_role, update_role, delete_role,
    get_activity_logs, get_modules
} from '../../utils/api-routes';

function* getRoles() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, api_urls + get_roles);
        if (data?.status) {
            yield put({ type: actionTypes.SET_ROLES, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Roles Saga Error:", error);
    }
}

function* createRoleSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield call(axios.post, api_urls + create_role, payload?.data);
        if (data?.status) {
            Swal.fire({ icon: "success", title: "Role Created Successfully", showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Failed To Create Role", text: error?.response?.data?.message || "Something went wrong", showConfirmButton: false, timer: 2000 });
        console.log("Create Role Saga Error:", error?.response?.data);
    }
}

function* updateRoleSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield call(axios.put, api_urls + update_role(payload?.id), payload?.data);
        if (data?.status) {
            Swal.fire({ icon: "success", title: "Role Updated Successfully", showConfirmButton: false, timer: 2000 });
            yield call(payload?.onComplete);
            yield put({ type: actionTypes.GET_ROLES });
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Failed To Update Role", text: error?.response?.data?.message || "Something went wrong", showConfirmButton: false, timer: 2000 });
        console.log("Update Role Saga Error:", error?.response?.data);
    }
}

function* deleteRoleSaga(action) {
    try {
        const { payload } = action;
        const result = yield Swal.fire({
            title: "Are You Sure To Delete This Role?",
            text: "This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        });

        if (result.isConfirmed) {
            const { data } = yield call(axios.delete, api_urls + delete_role(payload?.roleId));
            if (data?.status) {
                Swal.fire({ icon: "success", title: "Role Deleted Successfully", showConfirmButton: false, timer: 2000 });
                yield put({ type: actionTypes.GET_ROLES });
            }
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Cannot Delete Role", text: error?.response?.data?.message || "Something went wrong", showConfirmButton: false, timer: 2000 });
        console.log("Delete Role Saga Error:", error?.response?.data);
    }
}

function* getActivityLogsSaga(action) {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const params = action?.payload || {};
        const queryStr = new URLSearchParams(params).toString();
        const { data } = yield call(axios.get, api_urls + get_activity_logs + (queryStr ? '?' + queryStr : ''));
        if (data?.status) {
            yield put({ type: actionTypes.SET_ACTIVITY_LOGS, payload: { results: data?.results, pagination: data?.pagination } });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Activity Logs Saga Error:", error);
    }
}

function* getModulesSaga() {
    try {
        const { data } = yield call(axios.get, api_urls + get_modules);
        if (data?.status) {
            yield put({ type: actionTypes.SET_MODULES, payload: data?.results });
        }
    } catch (error) {
        console.log("Get Modules Saga Error:", error);
    }
}

export default function* roleSaga() {
    yield takeLeading(actionTypes.GET_ROLES, getRoles);
    yield takeLeading(actionTypes.CREATE_ROLE, createRoleSaga);
    yield takeLeading(actionTypes.UPDATE_ROLE, updateRoleSaga);
    yield takeLeading(actionTypes.DELETE_ROLE, deleteRoleSaga);
    yield takeLeading(actionTypes.GET_ACTIVITY_LOGS, getActivityLogsSaga);
    yield takeLeading(actionTypes.GET_MODULES, getModulesSaga);
}
